import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import GuestForm from './guest-form'
import { useInternationalization } from '../../../features/i18n'

const GuestContent = ({handleClose, setStep, setSummaryData}) => {
  const data = useSelector(state => state.event.data)
  const { language } = useSelector(state => state.system)
  const { translate } = useInternationalization()

  const handleBack = () => {
    if(typeof setStep === 'function'){
      setStep('ticket')
    }
  }

  const {
    id,
    title,
  } = data

  const titleRendered = typeof title === 'string' ? title
    : title && title[language.name] ? title[language.name]
    : 'undefined'

  return (
    <div>
      {
        // Temporary disabled
        false &&
        <>
          <div className="lg:hidden">
            <p className="text-sm text-gray-444 mb-4 lg:mb-5 cursor-pointer">
              <Link to={`/event/${id}/detail`}>
                &larr; Back
              </Link>
            </p>
          </div>
          <p
            className="hidden lg:block text-sm text-gray-444 mb-4 lg:mb-5 cursor-pointer"
            onClick={handleBack}
          >
            &larr; Back
          </p>
        </>
      }
      <h1 className="text-lg lg:text-2xl mb-2 font-primary font-bold">
        {translate('GUEST', 'plural')}
      </h1>
      <p className="text-sm text-gray-444">
        {titleRendered}
      </p>

      <hr className="my-8 lg:my-10"/>

      <GuestForm setStep={setStep} setSummaryData={setSummaryData}/>
    </div>
  )
}

export default GuestContent
